module.exports = __webpack_public_path__ + "static/media/SmartCity.6586c675.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/SmartCity.svg
// module id = 248
// module chunks = 0